/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PolicyViolationAction = {
    Warn: 'WARN',
    MustEncrypt: 'MUST_ENCRYPT',
    Quarantine: 'QUARANTINE',
    Block: 'BLOCK'
} as const;

export type PolicyViolationAction = typeof PolicyViolationAction[keyof typeof PolicyViolationAction];



